import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoadingSenseiComponent } from '../../activities/post-activity/grading-loading/loading-sensei/loading-sensei.component';

@Component({
  selector: 'dojo-challenge-grading-loading',
  standalone: true,
  imports: [LoadingSenseiComponent],
  templateUrl: './challenge-grading-loading.component.html',
  styleUrl: './challenge-grading-loading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChallengeGradingLoadingComponent {}
